import { render, staticRenderFns } from "./allReservationsPage.vue?vue&type=template&id=22d90626&scoped=true&"
import script from "./allReservationsPage.vue?vue&type=script&lang=js&"
export * from "./allReservationsPage.vue?vue&type=script&lang=js&"
import style0 from "./allReservationsPage.vue?vue&type=style&index=0&id=22d90626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d90626",
  null
  
)

export default component.exports